<template>
  <div class="mask" :class="{ maskActive: isOpen }" @click="closeSelf" />
  <transition name="slide-up">
    <div v-if="dataLoad && isOpen" id="dialog-market" class="dialog-bottom dialog-item">
      <div
        class="close-dialog dialog-mask mask"
        data-target="#dialog-market"
        @click.prevent="closeSelf"
      />
      <div class="addon-dialog">
        <div class="addon-dialog-content">
          <a class="r-lightbox__close" @click.prevent="closeSelf" />
          <div class="addon-item-detail clearfix">
            <div class="addon-item-img">
              <new-image
                v-if="selected.Images.length !== 0"
                :url="selected.Images[0].Url"
                :size="'_w318_h397'"
                :name="allData.Name"
              />
            </div>
            <div class="addon-item-info">
              <h3 class="item-name">{{ allData.Name }}</h3>
              <div class="item-price">
                <span class="sell-price">NT$ {{ mapSellPrice }}</span>
                <span
                  v-if="allData.SellPrice !== allData.OriginPrice || allData.EventPrice > 0"
                  class="origin-price"
                >
                  NT$ {{ allData.OriginPrice.toLocaleString() }}
                </span>
              </div>
              <div v-for="event in allData.Events" :key="event.ID" class="h6 py-2">
                <p>(活動) {{ event.Name }}</p>
              </div>
              <a class="addon-dialog-btn" @click.prevent="showProductInfo(allData)"> 商品資訊 </a>
              <div class="addon-select-block">
                <ul class="product-color addon-product-color">
                  <li
                    v-for="color in allData.Colors"
                    :key="color.ID"
                    class="item-color"
                    :class="{ active: color.ID === selected.ID }"
                    @click="changeImg(color.ID)"
                  >
                    <img :src="color.PintSizePictureUrl + '?w=20&amp;h=20'" />
                  </li>
                </ul>
                <ul class="addon-size-wrap">
                  <li
                    v-for="spec in selected.Specs"
                    :key="spec.ID"
                    :class="{
                      weak: spec.Stock === 0,
                      selected: spec.ID === selectedSpecID,
                      preshow: allData.IsPreShow,
                    }"
                    @click="selectSpec(spec)"
                  >
                    {{ spec.Name }} {{ spec.Description }}
                  </li>
                </ul>
                <div class="addon-select-pc">
                  <div class="UiQuantity">
                    <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="reduceCount">
                      –
                    </a>
                    <span class="UiQuantity__text">{{ counter }}</span>
                    <a
                      class="UiQuantity__btn UiQuantity__btn--plus"
                      @click.prevent="addCount(selectedSpec === null ? 1 : selectedSpec.Stock)"
                    >
                      ＋
                    </a>
                  </div>
                  <button
                    class="btn btn-add-cart"
                    :class="btnStyleGenerate"
                    @click.prevent="addToCart"
                  >
                    {{ btnDescriptionGenerate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="addon-select-m">
            <div class="UiQuantity">
              <a class="UiQuantity__btn UiQuantity__btn--minus" @click.prevent="reduceCount">-</a>
              <span class="UiQuantity__text">{{ counter }}</span>
              <a
                class="UiQuantity__btn UiQuantity__btn--plus"
                @click.prevent="addCount(selectedSpec === null ? 1 : selectedSpec.Stock)"
              >
                +
              </a>
            </div>
            <button class="btn btn-add-cart" :class="btnStyleGenerate" @click.prevent="addToCart">
              {{ btnDescriptionGenerate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import useCommonDialog from '@global/composable/useCommonDialog';
import NewImage from '@global/components/common/Image/NewImage.vue';

const props = defineProps({
  dialogData: {
    type: Object,
    required: true,
  },
  showInfo: {
    type: Boolean,
    default: false,
  },
  noArrivalNotice: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['changeOpen', 'changeSelect']);

const {
  isOpen,
  allData,
  dataLoad,
  mapSellPrice,
  btnStyleGenerate,
  btnDescriptionGenerate,
  selectedSpec,
  selected,
  selectedSpecID,
  selectSpec,
  counter,
  addCount,
  reduceCount,
  changeImg,
  closeSelf,
  addToCart,
  showProductInfo,
} = useCommonDialog(
  {
    dialogData: props.dialogData,
    noArrivalNotice: props.noArrivalNotice,
  },
  emit,
);
</script>
